<div class="bg-neutral-0 flex flex-col gap-3 rounded-lg border border-neutral-200 p-4">
  <div class="flex items-start justify-between gap-3">
    <label class="flex items-start gap-3">
      <input
        type="checkbox"
        class="mt-1"
        [checked]="confirmed()"
        (change)="toggle($event)"
      />
      <span class="font-medium text-neutral-700">
        {{ candidate().protocol.name || ("protocols.import.unnamed" | translate) }}
      </span>
    </label>

    @if (candidate().isNew) {
      <span class="bg-success-50 text-success-700 shrink-0 rounded-full px-3 py-1 text-xs font-medium">
        {{ "protocols.import.badge.new" | translate }}
      </span>
    } @else {
      <span class="bg-info-50 text-info-700 shrink-0 rounded-full px-3 py-1 text-xs font-medium">
        {{ "protocols.import.badge.edit" | translate }}
      </span>
    }
  </div>

  <protocols-code-view
    [protocol]="candidate().protocol"
    [unresolved]="unresolvedCodes()"
  ></protocols-code-view>

  @if (hasDetails()) {
    <div class="flex flex-col gap-2 border-t border-neutral-100 pt-2">
      <button
        type="button"
        class="flex w-fit items-center gap-1 text-xs font-medium text-neutral-500 hover:text-neutral-700"
        (click)="toggleExpanded()"
      >
        <span>{{ expanded() ? "▾" : "▸" }}</span>
        {{ "protocols.import.validationDetails" | translate }}
      </button>

      @if (expanded()) {
        <div class="flex flex-col gap-2 rounded-md bg-neutral-50 p-3 text-xs">
          @if (parseErrors().length) {
            <ul class="text-error-600 list-disc ps-5">
              @for (error of parseErrors(); track $index) {
                <li>{{ error }}</li>
              }
            </ul>
          }
          @if (validationErrors().length) {
            <ul class="text-error-600 list-disc ps-5">
              @for (error of validationErrors(); track $index) {
                <li>{{ error }}</li>
              }
            </ul>
          }
        </div>
      }
    </div>
  }
</div>
